module.exports = __webpack_public_path__ + "static/media/kocka2COLLECTIVIBE.12e3da71.jpg";